import { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from 'reactstrap'
import { InputContainer, Markdown, Checkbox, If } from 'components/ideal-core-ui'
import s from './ScheduleTaskModal.scss'
import Select from 'react-select'
import {
  IoIosCall,
  IoIosMail,
  IoIosPeople,
  IoMdCafe,
  IoMdRestaurant,
  IoIosPaper
} from 'react-icons/io'
import { FaCheckCircle } from 'react-icons/fa'
import cn from 'classnames'
import moment from 'moment'
import { APP_CONSTANTS } from 'utils/constants'
import { fromTask, fromCompanies } from 'utils/serializers'
import { fromContacts, fromCompany } from './serializers'
import DatePicker from 'react-datepicker'
import '!style-loader!css-loader!react-datepicker/dist/react-datepicker.css' // eslint-disable-line
import { makeGetRequest } from 'utils/api'
import capitalize from 'lodash/capitalize'
import { getUser, getDateFormat } from 'utils/authService'
import { timezoneDate, utcDate, utcCurrentDate } from 'utils/helpers'

const styles = {
  option: (styles, { data }) => {
    return {
      ...styles,
      color: data.color
    }
  },
  singleValue: (styles, { data }) => {
    return {
      ...styles,
      color: data.color
    }
  }
}

class ScheduleTaskModal extends Component {
  _isMounted = false
  state = {
    task:
      this.props.edit && this.props.selectedTask
        ? { ...fromTask(this.props.selectedTask) }
        : {
            type: 'TASK',
            proposals: [],
            subject: this.props.defaultSubject || 'Task ',
            startDate: utcCurrentDate(),
            dueDate: moment(utcCurrentDate()).add(1, 'hours').toDate(),
            notes: '',
            company: this.props.company ?? '',
            contacts: [],
            contact: ''
          },
    requiredFields: ['subject', 'assignee'],
    proposalCompany: '',
    isSubjectPristine: true,
    isNotesPristine: true,
    error: false
  }

  componentDidMount() {
    this._isMounted = true
    this.getContactsForSelectedCompany(true)
  }

  componentDidUpdate() {
    this.getContactsForSelectedCompany()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getContactsForSelectedCompany = preserveContact => {
    const { task } = this.state
    if (!task.contacts.length && task.company.value) {
      this.getContacts(task.company.value, preserveContact)
    }
  }

  changeProperty = (value, property, cb) => {
    this.setState(
      {
        ...this.state,
        task: {
          ...this.state.task,
          [property]: value
        }
      },
      () => {
        cb && cb()
      }
    )
  }

  getContacts = async (id, preserveContact) => {
    const url = `/v1/contacts/company/${id}`
    const contacts = await makeGetRequest(url)
    const { contact } = this.state.task

    if (this._isMounted) {
      this.setState({
        ...this.state,
        task: {
          ...this.state.task,
          contacts,
          contact: preserveContact && contact.value ? contact : ''
        }
      })
    }
  }

  validateRequired = async () => {
    await this.setState({
      error: false
    })
    this.state.requiredFields.forEach(field => {
      if (!this.state.task[field]) {
        this.setState({
          error: true
        })
      }
    })
  }

  onSave = async cb => {
    await this.validateRequired()
    if (!this.state.error) {
      cb(this.state.task)
      this.props.onSaveTaskCb && this.props.onSaveTaskCb(this.state)
      this.props.toggleScheduleTaskModal()
    }
  }

  changeAssignee = value => {
    const assignee = this.props.users.find(assignee => assignee.value === value.value)
    this.changeProperty(assignee, 'assignee')
  }

  setProposalCompany = () => {
    if (this.state.task.proposals.length === 1) {
      const proposal = this.state.task.proposals[0]
      this.setState({
        ...this.state,
        task: {
          ...this.state.task,
          company: '',
          contact: ''
        },
        proposalCompany: proposal.company
          ? fromCompany(proposal.company)
          : {
              value: proposal.companyId,
              label: proposal.companyName
            }
      })
    } else {
      this.setState({
        ...this.state,
        task: {
          ...this.state.task,
          company: '',
          contact: ''
        },
        proposalCompany: ''
      })
    }
  }

  triggerCheckbox = proposal => {
    if (this.state.task.proposals.find(p => p.id === proposal.id)) {
      this.setState(
        {
          ...this.state,
          task: {
            ...this.state.task,
            proposals: this.state.task.proposals.filter(elem => elem.id !== proposal.id)
          }
        },
        () => {
          this.setProposalCompany()
        }
      )
    } else {
      this.setState(
        prevState => ({
          ...prevState,
          task: {
            ...prevState.task,
            proposals: [...prevState.task.proposals, proposal]
          }
        }),
        () => {
          this.setProposalCompany()
        }
      )
    }
  }

  markCompleted = () => {
    this.setState({
      ...this.state,
      task: {
        ...this.state.task,
        completed: true
      }
    })
  }

  markNotCompleted = () => {
    this.setState({
      ...this.state,
      task: {
        ...this.state.task,
        completed: false
      }
    })
  }

  updateSubject = cb => {
    if (this.state.isSubjectPristine) {
      this.setState(
        {
          ...this.state,
          task: {
            ...this.state.task,
            subject: `${capitalize(this.state.task.type)} ${
              this.state.task.contact.label || ''
            } - ${this.state.task.company.label || ''}`
          }
        },
        () => {
          cb && cb()
        }
      )
    }
  }

  updateNotes = () => {
    if (this.state.isNotesPristine) {
      this.setState({
        ...this.state,
        task: {
          ...this.state.task,
          notes: `
          ${this.state.task.company.label || ''}
${this.state.task.contact.label || ''} - ${this.state.task.contact.phone || ''} - ${
            this.state.task.contact.email || ''
          }
          `
        }
      })
    }
  }

  setNotesNotPristine = () => {
    this.setState({
      ...this.state,
      isNotesPristine: false
    })
  }

  setSubjectNotPristine = () => {
    this.setState({
      ...this.state,
      isSubjectPristine: false
    })
  }

  syncEndDate = () => {
    const { task } = this.state
    const { startDate, dueDate } = task
    if (moment(startDate).isAfter(moment(dueDate))) {
      const dueDate = moment(startDate).add(1, 'hours').toDate()
      this.setState({
        ...this.state,
        task: {
          ...this.state.task,
          dueDate
        }
      })
    }
  }

  render() {
    const {
      showScheduleTaskModal,
      toggleScheduleTaskModal,
      createTask,
      updateTask,
      users,
      deal,
      proposal,
      proposals,
      edit,
      markAsDone,
      markAsNotDone,
      deleteTask
    } = this.props
    const { task, proposalCompany } = this.state
    const {
      type,
      subject,
      notes,
      assignee,
      id,
      category,
      completed,
      startDate,
      dueDate,
      company,
      contact,
      dealId,
      dealName
    } = task

    return (
      <Modal
        data-cy="add_task_modal"
        keyboard={false}
        backdrop="static"
        isOpen={showScheduleTaskModal}
        toggle={() => toggleScheduleTaskModal()}
        size="lg"
      >
        <ModalHeader toggle={() => toggleScheduleTaskModal()} className={s.modalHeader}>
          {edit ? 'Edit Task' : 'Schedule a Task'}
        </ModalHeader>
        <ModalBody>
          <h5>
            <a
              href={
                deal
                  ? `/opportunities/${deal.id}`
                  : proposal
                    ? `/proposals/${proposal.id}`
                    : this.props.company
                      ? `/companies/${this.props.company.value}`
                      : `/opportunities/${dealId}`
              }
            >
              {deal
                ? deal.name
                : proposal
                  ? proposal.name
                  : this.props.company
                    ? this.props.company.label
                    : dealName}
            </a>
          </h5>
          <label className={s.label}>Task Type</label>
          <ButtonGroup className={s.buttonGroup}>
            <Button
              onClick={() => this.changeProperty('CALL', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'CALL'
              })}
            >
              <IoIosCall />
              <span>{APP_CONSTANTS.TaskTypes.CALL}</span>
            </Button>
            <Button
              onClick={() => this.changeProperty('EMAIL', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'EMAIL'
              })}
            >
              <IoIosMail />
              <span>{APP_CONSTANTS.TaskTypes.EMAIL}</span>
            </Button>
            <Button
              onClick={() => this.changeProperty('TASK', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'TASK'
              })}
            >
              <IoIosPaper />
              <span>{APP_CONSTANTS.TaskTypes.TASK}</span>
            </Button>
            <Button
              onClick={() => this.changeProperty('MEET', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'MEET'
              })}
            >
              <IoIosPeople />
              <span>{APP_CONSTANTS.TaskTypes.MEET}</span>
            </Button>
            <Button
              onClick={() => this.changeProperty('LUNCH', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'LUNCH'
              })}
            >
              <IoMdCafe />
              <span>{APP_CONSTANTS.TaskTypes.LUNCH}</span>
            </Button>
            <Button
              onClick={() => this.changeProperty('DINNER', 'type', () => this.updateSubject())}
              className={cn(s.taskType, {
                [s.active]: type === 'DINNER'
              })}
            >
              <IoMdRestaurant />
              <span>{APP_CONSTANTS.TaskTypes.DINNER}</span>
            </Button>
          </ButtonGroup>
          <If condition={edit}>
            <div className={s.markAsDoneWrapper}>
              <FaCheckCircle
                onClick={() => {
                  if (completed) {
                    markAsNotDone(id)
                    this.markNotCompleted()
                    return
                  }
                  markAsDone(id, category)
                  this.markCompleted()
                }}
                className={cn({
                  [s.markAsDone]: !completed,
                  [s.done]: completed
                })}
              />
              {completed ? 'This Task was Marked as Completed' : 'Mark Task as Completed'}
            </div>
          </If>
          <If
            condition={!edit && deal && proposals?.length}
            fallback={
              proposal && (
                <div className={s.proposalsWrapper}>
                  <span>{proposal.name}</span>
                </div>
              )
            }
          >
            <div className={s.proposalsWrapper}>
              <label className={s.label}>
                Check if this task applies to one or more proposals (if none checked, task will be
                applied to opportunity). <br />
                We recommend creating tasks for the opportunity itself or for one proposal at a time
                so we can keep contacts linked correctly.
              </label>
              {deal &&
                proposals?.length &&
                proposals.map(proposal => {
                  return (
                    <div key={proposal.id} className={s.pullLeft}>
                      <Checkbox
                        isChecked={!!task.proposals.find(p => proposal.id === p.id)}
                        triggerCheckbox={() => this.triggerCheckbox(proposal)}
                      />
                      <span>{proposal.name}</span>
                    </div>
                  )
                })}
            </div>
          </If>
          <InputContainer
            type="text"
            value={subject}
            text={subject}
            placeholder="Enter task subject (i.e Create Proposal)"
            cb={value => {
              this.changeProperty(value, 'subject', () => this.setSubjectNotPristine())
            }}
            cy="task_subject"
          />
          <div className={cn(s.dateWrapper, s.marginTop10)}>
            <div className={cn(s.date, s.pullLeft)}>
              <label className={s.label}>Start Date</label>
              <DatePicker
                selected={moment(
                  timezoneDate(startDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                selectsStart
                startDate={moment(
                  timezoneDate(startDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                endDate={moment(
                  timezoneDate(dueDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                onChange={value => {
                  if (!value) return
                  this.changeProperty(utcDate(value), 'startDate', this.syncEndDate)
                }}
                showTimeSelect
                timeFormat="h:mm aa"
                timeIntervals={15}
                dateFormat={`${getDateFormat()
                  .replace('YYYY', 'yyyy')
                  .replace('DD', 'dd')} h:mm aa`}
                timeCaption="time"
                placeholderText="Select start date"
                className={s.calendar}
              />
            </div>
            <div className={cn(s.date, s.pullLeft)}>
              <label className={s.label}>End Date</label>
              <DatePicker
                selected={
                  (dueDate &&
                    moment(
                      timezoneDate(dueDate, 'HH:mm:ss'),
                      `${getDateFormat()} HH:mm:ss`
                    ).toDate()) ||
                  (startDate && moment(startDate).add(1, 'hours').toDate())
                }
                selectsEnd
                startDate={moment(
                  timezoneDate(startDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                endDate={moment(
                  timezoneDate(dueDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                onChange={value => {
                  this.changeProperty(utcDate(value), 'dueDate')
                }}
                minDate={moment(
                  timezoneDate(startDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                showTimeSelect
                timeFormat="h:mm aa"
                timeIntervals={15}
                dateFormat={`${getDateFormat()
                  .replace('YYYY', 'yyyy')
                  .replace('DD', 'dd')} h:mm aa`}
                timeCaption="time"
                placeholderText="Select end date"
                className={s.calendar}
              />
            </div>
          </div>
          {deal || proposal || this.props.company ? (
            <>
              {!this.props.company && (
                <div className={cn(s.marginTop10, s.company, s.pullLeft)}>
                  <label className={s.label}>{deal ? 'Companies' : 'Company'}</label>
                  <Select
                    value={company.value ? company : ''}
                    onChange={value =>
                      this.changeProperty(value, 'company', async () => {
                        await this.getContacts(value.value)
                        this.updateSubject(this.updateNotes)
                      })
                    }
                    options={
                      deal
                        ? task.proposals.length !== 1
                          ? fromCompanies(deal.dealCompanies)
                          : [
                              {
                                value: proposalCompany
                                  ? proposalCompany.value
                                  : task.company
                                    ? task.company.value
                                    : '',
                                label: proposalCompany
                                  ? proposalCompany.label
                                  : task.company
                                    ? task.company.label
                                    : ''
                              }
                            ]
                        : fromCompanies([proposal.company])
                    }
                    styles={styles}
                    id="company_select_cy"
                  />
                </div>
              )}
              {task.company && (
                <div className={cn(s.marginTop10, s.company, s.pullLeft)}>
                  <label className={s.label}>Contacts</label>
                  <Select
                    value={contact.value ? contact : ''}
                    onChange={value =>
                      this.changeProperty(value, 'contact', async () => {
                        await this.updateSubject()
                        this.updateNotes()
                      })
                    }
                    options={fromContacts(task.contacts)}
                  />
                </div>
              )}
            </>
          ) : (
            <div className={s.taskCompanyContact}>
              {task.company && !this.props.company && (
                <span>
                  Company:{' '}
                  <span style={{ color: task.company.color }}>
                    <b>{task.company.label}</b>
                  </span>
                </span>
              )}
              {task.contact && (
                <span>
                  Contact: <b>{task.contact.label}</b>
                </span>
              )}
              {!this.props.company && (
                <div>
                  <i>
                    If you’d like to change Client/Contact, please do so from the opportunity, by
                    clicking the blue link above.
                  </i>
                </div>
              )}
            </div>
          )}
          <div className={s.clearfix} />
          <div className={cn(s.marginTop10, s.assignee)}>
            <label className={s.label}>Assigned To</label>
            <Select
              value={assignee}
              onChange={value => this.changeAssignee(value)}
              options={users}
              id="user_select_cy"
            />
          </div>
          <div className={s.clearfix} />
          <label className={s.label}>Notes</label>
          <Markdown
            initialValue={notes}
            shouldDisplayDefaultText={edit && notes ? false : this.state.isNotesPristine}
            saveCb={value => {
              this.changeProperty(value, 'notes', () => this.setNotesNotPristine())
            }}
          />
          {this.state.error && <p className={s.error}>All required fields must have values!</p>}
        </ModalBody>
        <ModalFooter>
          {edit && getUser().id === task.createdBy && (
            <Button
              data-cy="delete_task"
              className={s.delete}
              color="danger"
              onClick={() => {
                deleteTask(this.state.task)
                toggleScheduleTaskModal()
              }}
            >
              Delete
            </Button>
          )}
          <Button
            data-cy="save_btn"
            className={s.saveBtn}
            onClick={() => this.onSave(edit ? updateTask : createTask)}
          >
            Save
          </Button>
          <Button color="secondary" onClick={() => toggleScheduleTaskModal()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ScheduleTaskModal
